import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = {
  class: "group_remain_manager"
};
const _hoisted_2 = {
  class: "base_screen_header"
};

const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, null, -1);

import DataCollectTable from '@com/table/DataCollectTable.vue';
import { OP_KEY, COLUMN_TYPE, OPERATIONS, operationsHander } from "@com/table/tableOperations";
import { ref, reactive } from 'vue';
import { Search } from '@element-plus/icons-vue';
import useRoute from "@util/router";
import api from "@api/groupRemain";
import $ from "@util/base";
import { $msg } from '@/common/ui/msg';
export default {
  __name: 'GroupRemainManager',

  setup(__props) {
    const route = useRoute();
    const baseOptions = ref([]);
    getConfig();

    function getConfig() {
      api.base(val => {
        baseOptions.value = val;
      });
    }

    const total = ref(0);
    const data = ref([]);
    const base = ref(route.query().base || '');
    const name = ref(route.query().name || '');
    const code = ref(route.query().code || '');

    function searchBase(val) {
      route.replaceQuery('base', val);
    }

    function searchName(val) {
      route.replaceQuery('name', val);
    }

    function searchCode(val) {
      route.replaceQuery('code', val);
    }

    function getOperations() {
      return [OPERATIONS.viewDetails];
    }

    const tableConfig = {
      showIndex: true,
      operations: {
        label: '操作',
        width: 120,
        operations: getOperations
      },
      column: [{
        label: '产品图片',
        prop: 'mainPic',
        type: COLUMN_TYPE.picture,
        width: 100
      }, {
        label: '产品名称',
        prop: 'travelName'
      }, {
        label: '产品编号',
        prop: 'travelCode',
        width: 150
      }, {
        label: '现有团期',
        prop: 'nowGroupNum',
        width: 150,
        sortable: 'custom'
      }, {
        label: '发团日期',
        prop: 'startGroupTime',
        width: 150
      }, {
        label: '结束日期',
        prop: 'endGroupTime',
        width: 150
      }, {
        label: '基地所属',
        prop: 'shopName',
        width: 150
      }]
    };
    const opHander = operationsHander();
    opHander.install(OP_KEY.viewDetails, data => {
      route.push({
        name: 'groupremainorder',
        query: {
          code: data.travelCode
        }
      });
    });
    getData();
    route.watchRouter("groupremainmanager", () => {
      getData();
    });

    function getData() {
      let routeQuery = route.query();
      api.manageList({
        shopCode: routeQuery.base,
        name: routeQuery.name,
        code: routeQuery.code,
        num: routeQuery.num,
        page: routeQuery.p,
        size: routeQuery.s
      }, val => {
        data.value = val.itemList;
        total.value = val.total;
      });
    }

    function close() {}

    function handleSortChange({
      column,
      prop,
      order
    }) {
      // 自定义排序
      if ('ascending' == order) {
        route.replaceQuery('num', 1);
      } else if ('descending' == order) {
        route.replaceQuery('num', 2);
      }
    }

    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_main = _resolveComponent("el-main");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_main, {
        class: "base_main_content"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createVNode(_component_el_form, {
          inline: true,
          class: "base_search_form",
          onSubmit: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"]))
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: base.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => base.value = $event),
              onChange: searchBase,
              placeholder: "请选择基地",
              clearable: ""
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(baseOptions.value, (item, index) => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: index,
                  label: item.label,
                  value: item.value
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: name.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => name.value = $event),
              "onKeyup[native]": searchName,
              onChange: searchName,
              placeholder: "产品名称",
              clearable: "",
              "suffix-icon": _unref(Search)
            }, null, 8, ["modelValue", "suffix-icon"])]),
            _: 1
          }), _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: code.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => code.value = $event),
              "onKeyup[native]": searchCode,
              onChange: searchCode,
              placeholder: "产品编码",
              clearable: "",
              "suffix-icon": _unref(Search)
            }, null, 8, ["modelValue", "suffix-icon"])]),
            _: 1
          })]),
          _: 1
        })]), _createVNode(DataCollectTable, {
          data: data.value,
          total: total.value,
          config: tableConfig,
          onOperationsHander: _unref(opHander).receive,
          onSortChange: handleSortChange
        }, null, 8, ["data", "total", "onOperationsHander"])]),
        _: 1
      })]);
    };
  }

};